import { Button } from "@mui/material";
import React, { useState } from "react";
import "./PasswordGuard.css";

function PasswordGuardContent({ onButtonClick }) {
    return (
        <>
            <div id="root">
                <div id="container" className="progress-container">
                    <div className="progress-title">
                        <p>
                            The webpage is under maintenance. Please click{" "}
                            <a
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                here
                            </a>{" "}
                            to go back.
                        </p>
                        <br />
                        <p>
                            此網頁現正維護中，請
                            <a
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                按此
                            </a>
                            返回上一頁。
                        </p>
                        <br />
                        <p>
                            此网页现正维护中，请
                            <a
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                按此
                            </a>
                            返回上一页。
                        </p>
                        <Button onClick={onButtonClick}> </Button>
                    </div>
                </div>
            </div>
        </>
    );
}

function PasswordGuard({ children }) {
    const [inputPW, setInputPW] = useState("");
    const onButtonClick = () => {
        const password = window.prompt();
        setInputPW(password);
    };
    if (inputPW !== "edbeformss2022") {
        return <PasswordGuardContent onButtonClick={onButtonClick} />;
    } else {
        return children;
    }
}

export default PasswordGuard;
